export const KEY_TOKEN_AUTH = '@TOFZD:token';

export const setSession = (key:string, accessToken: string) => {
	if (accessToken)
		localStorage.setItem(key, accessToken);
	else 
		localStorage.removeItem(key);
}
